import { Card } from "@/components/ui/card";
import { Package, Play } from "lucide-react";
import { getImageUrl } from "@/utils/imageUrl";

export default function ShowcaseProductCard({ product, onClick }) {
  const hasVideo = !!product.video;

  return (
    <Card 
      className="group overflow-hidden cursor-pointer hover:border-primary/50 hover:shadow-lg transition-all duration-300"
      onClick={() => onClick(product)}
      data-testid={`showcase-product-${product.sku}`}
    >
      <div className="relative h-48 overflow-hidden bg-gray-100">
        {product.image ? (
          <img 
            src={getImageUrl(product.image)} 
            alt={product.heading}
            className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        <div 
          className={`absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-muted to-muted/80 ${product.image ? 'hidden' : 'flex'}`}
        >
          <Package className="h-12 w-12 text-muted-foreground/50 mb-2" />
          <span className="text-sm text-muted-foreground">No Image</span>
        </div>
        
        {/* Video indicator badge */}
        {hasVideo && (
          <div className="absolute top-2 right-2 bg-primary text-white px-2 py-1 rounded text-xs flex items-center gap-1">
            <Play className="h-3 w-3" fill="currentColor" />
            Video
          </div>
        )}
      </div>
      <div className="p-4 space-y-2">
        <div className="flex items-center justify-between">
          <span className="text-xs font-mono text-primary bg-primary/10 px-2 py-0.5 rounded">
            {product.sku}
          </span>
        </div>
        <h3 className="font-semibold text-base group-hover:text-primary transition-colors line-clamp-2" style={{ fontFamily: 'Manrope' }}>
          {product.heading}
        </h3>
        <div className="space-y-1 text-sm text-muted-foreground">
          <div className="flex">
            <span className="w-24 font-medium text-foreground/70">Material:</span>
            <span className="flex-1 truncate">{product.material}</span>
          </div>
          <div className="flex">
            <span className="w-24 font-medium text-foreground/70">Dimensions:</span>
            <span className="flex-1 truncate">{product.dimensions}</span>
          </div>
          <div className="flex">
            <span className="w-24 font-medium text-foreground/70">Use:</span>
            <span className="flex-1 truncate">{product.use}</span>
          </div>
        </div>
      </div>
    </Card>
  );
}
